import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { InfoView } from '../reducers/InfoMenuReducer'
import { boreholeInfoActions } from '../actions/BoreholeInfoActions'
import { RootState } from 'src/Store'
import { virtualBoreholeInfoActions } from './VirtualBoreholeInfoActions'
import { DataAction } from 'src/CustomTypes'

export const CURRENT_VIEW = 'INFO_MENU_ACTIONS_CURRENT_VIEW'

interface InfoMenuActions {
  currentView: (viewType: InfoView) => DataAction<InfoView>
  boreholeInfo: (coords: number[]) => ThunkAction<Promise<void>, RootState, {}, AnyAction>
  virtualBoreholeInfo: (coords: number[]) => ThunkAction<Promise<void>, RootState, {}, AnyAction>
}

export const infoMenuActions: InfoMenuActions = {
  currentView: (viewType: InfoView): DataAction<InfoView> => {
    return {
      type: CURRENT_VIEW,
      data: viewType
    }
  },
  // Thunk actions
  boreholeInfo: (coords: number[]): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>): Promise<void> => {
      dispatch(infoMenuActions.currentView(InfoView.BoreholeInfo))
      await dispatch(boreholeInfoActions.setCoordinate(coords))
    }
  },
  // Thunk actions
  virtualBoreholeInfo: (coords: number[]): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>): Promise<void> => {
      dispatch(infoMenuActions.currentView(InfoView.VirtualBoreholeInfo))
      await dispatch(virtualBoreholeInfoActions.updateVirtualBorehole(coords))
    }
  }
}
